<div class="container">
  <div class="header">
    <div class="title">
      <h1>{{ showWelcomeMessage ? "Welcome to Driver Safety" : "My Day" }}</h1>
    </div>
  </div>

  <div class="cards-container" *ngIf="showWelcomeMessage">
    <h3>
      Driver Safety is here to help you identify and manage your drivers risk and
      compliance so you can have peace of mind your fleet operates safely and efficiently.
    </h3>
  </div>

  <div class="cards-container" *ngIf="!showWelcomeMessage">
    <div class="header-container">
      <span class="subtitle">At a Glance</span>
      <div class="new-radio-slider button-toggle-right main-slider">
        <input
          type="radio"
          name="slider"
          id="option7"
          class="new-radio-input"
          [value]="'7'"
          [(ngModel)]="selectedTimePeriod"
        />
        <label (click)="onTimePeriodChange('7')" for="option7" class="new-radio-label"
          >7 Days</label
        >
        <input
          type="radio"
          name="slider"
          id="option30"
          class="new-radio-input"
          [value]="'30'"
          [(ngModel)]="selectedTimePeriod"
        />
        <label (click)="onTimePeriodChange('30')" for="option30" class="new-radio-label"
          >30 Days</label
        >
        <input
          type="radio"
          name="slider"
          id="option90"
          class="new-radio-input"
          [value]="'90'"
          [(ngModel)]="selectedTimePeriod"
        />
        <label (click)="onTimePeriodChange('90')" for="option90" class="new-radio-label"
          >90 Days</label
        >
        <div class="slider" #slider></div>
      </div>
    </div>

    <div class="cards-row">
      <!-- Total Drivers -->
      <div
        class="card"
        *ngIf="hasDriverProfilePermissions()"
        (click)="goToPage('/drivers')"
      >
        <span class="card-title">Total Drivers</span>
        <span class="card-amount">
          <ng-container
            *ngIf="isLoadingAtAGlanceMetrics; else totalDrivers"
            [ngTemplateOutlet]="loadingTemplate"
          ></ng-container>
          <ng-template #totalDrivers>
            {{ metrics?.totalDriversCurrent ? metrics.totalDriversCurrent : 0 }}
          </ng-template>
        </span>
        <app-percentage-difference
          *ngIf="!isLoadingAtAGlanceMetrics"
          [value]="metrics?.percentageDifferenceDrivers"
        ></app-percentage-difference>
      </div>

      <!-- Avg Driver Score -->
      <div
        class="card"
        *ngIf="canViewDriverScore()"
        (click)="goToPageWithTab('/analytics/analytics-drivers', 'scores')"
      >
        <span class="card-title">Avg Driver Score</span>
        <span class="card-amount">
          <ng-container
            *ngIf="isLoadingAtAGlanceMetrics; else avgDriverScore"
            [ngTemplateOutlet]="loadingTemplate"
          ></ng-container>
          <ng-template #avgDriverScore>
            {{ metrics?.avgDriverScoreCurrent ? metrics.avgDriverScoreCurrent / 10 : 0 }}
          </ng-template>
        </span>
        <app-percentage-difference
          *ngIf="!isLoadingAtAGlanceMetrics"
          [value]="metrics?.percentageDifferenceScores"
        ></app-percentage-difference>
      </div>

      <!-- Total Events -->
      <div
        class="card"
        *ngIf="canViewTotalEvents()"
        (click)="goToPageWithDateRange('/events', selectedTimePeriod)"
      >
        <span class="card-title">Total Events</span>
        <span class="card-amount">
          <ng-container
            *ngIf="isLoadingAtAGlanceMetrics; else totalEvents"
            [ngTemplateOutlet]="loadingTemplate"
          ></ng-container>
          <ng-template #totalEvents>
            {{ metrics?.totalEventsCurrent ? metrics.totalEventsCurrent : 0 }}
          </ng-template>
        </span>
        <app-percentage-difference
          *ngIf="!isLoadingAtAGlanceMetrics"
          [value]="metrics?.percentageDifferenceEvents"
          [invertColors]="true"
        ></app-percentage-difference>
      </div>

      <!-- Total Interventions -->
      <div
        class="card"
        *ngIf="hasInterventionsPermissions()"
        (click)="goToPageWithView('/intervention/coaching', 'list')"
      >
        <span class="card-title">Total Interventions</span>
        <span class="card-amount">
          <ng-container
            *ngIf="isLoadingAtAGlanceMetrics; else totalInterventions"
            [ngTemplateOutlet]="loadingTemplate"
          ></ng-container>
          <ng-template #totalInterventions>
            {{
              metrics?.totalInterventionsCurrent ? metrics.totalInterventionsCurrent : 0
            }}
          </ng-template>
        </span>
        <app-percentage-difference
          *ngIf="!isLoadingAtAGlanceMetrics"
          [value]="metrics?.percentageDifferenceInterventions"
          [invertColors]="true"
        ></app-percentage-difference>
      </div>
    </div>
  </div>

  <div
    *ngIf="!showWelcomeMessage"
    class="rectangles-container"
    [ngClass]="{ 'full-width': showFullSizeTable }"
  >
    <!-- My Followed Drivers -->
    <div class="rectangle" *ngIf="hasDriverProfilePermissions()">
      <div class="table-subtitle">My Followed Drivers</div>
      <div class="container-table">
        <div class="table-responsive">
          <div class="table-container scrollable-container">
            <table
              mat-table
              [dataSource]="myDriversList"
              matSort
              matSortDisableClear
              [matSortActive]="defaultSortActiveMyDrivers"
              [matSortDirection]="defaultSortDirectionMyDrivers"
              class="my-followed-drivers-table-header-sticky"
              (matSortChange)="announceSortChangeMyDrivers($event)"
            >
              <!-- Column: driverName -->
              <ng-container matColumnDef="driverName" class="driver-name-column">
                <th mat-header-cell mat-sort-header="driverName" *matHeaderCellDef>
                  Name
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="name">
                    <img
                      [src]="getImageUrl(element?.driverId)"
                      appImgFallback
                      alt="Avatar"
                      class="user-avatar"
                    />
                    {{ toTitleCase(element?.driverName) }}
                  </div>
                </td>
              </ng-container>

              <!-- Column: terminal -->
              <ng-container matColumnDef="terminal">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Terminal</th>
                <td mat-cell *matCellDef="let row">
                  {{ row?.terminal }}
                </td>
              </ng-container>

              <ng-container matColumnDef="driverScore">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Score</th>
                <td mat-cell *matCellDef="let element">
                  <div
                    class="block-count-change"
                    *ngIf="
                      isScoreBlockVisible(element?.driverScore);
                      else scoreNotAvailableTemplate
                    "
                  >
                    <span class="count-change">{{
                      (element?.driverScore ?? 0) / 10 | number : "1.0-1"
                    }}</span>
                    <app-star-rating [type]="element.scoringTier"></app-star-rating>
                  </div>
                  <ng-template #scoreNotAvailableTemplate> - </ng-template>
                </td>
              </ng-container>

              <!-- Column: scoreChangeType -->
              <ng-container matColumnDef="scoreChangeType">
                <th mat-header-cell *matHeaderCellDef>Change</th>
                <td mat-cell *matCellDef="let element">
                  <app-score-change
                    [scoreChangeType]="element?.scoreChangeType"
                    [scoreChange]="element?.scoreChange"
                  ></app-score-change>
                </td>
              </ng-container>

              <!-- Column: driverId -->
              <ng-container matColumnDef="driverId">
                <th mat-header-cell mat-sort-header="driverId" *matHeaderCellDef>
                  Driver Id
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.driverId }}
                </td>
              </ng-container>

              <!-- Column: hireDate -->
              <ng-container matColumnDef="hireDate">
                <th mat-header-cell mat-sort-header="hireDate" *matHeaderCellDef>
                  Hire Date
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ getFormattedHireDate(element?.hireDate) }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsMyDrivers"></tr>
              <tr
                mat-row
                class="clickable"
                *matRowDef="let row; columns: displayedColumnsMyDrivers"
                (click)="onDriverRowClick(row)"
              ></tr>
            </table>
          </div>
          <div
            class="no-data"
            *ngIf="showNoDataAvailableMyDrivers && !isLoadingMyDriversList"
          >
            No data available
          </div>
          <ng-container *ngIf="isLoadingMyDriversList">
            <ng-container *ngTemplateOutlet="loadingTemplateOverlay"></ng-container>
          </ng-container>
          <mat-paginator
            *ngIf="!isLoadingMyDriversList"
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons
            [pageSize]="pageEventMyDrivers.pageSize"
            [length]="paginationParamsMyDrivers.total"
            [pageIndex]="pageEventMyDrivers.pageIndex"
            (page)="onPageChangeMyDrivers($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- My Incomplete Interventions -->
    <div class="rectangle" *ngIf="hasInterventionsPermissions()">
      <div class="table-subtitle">My Incomplete Interventions</div>
      <div class="container-table">
        <div class="table-responsive">
          <div class="table-container scrollable-container">
            <table
              mat-table
              [dataSource]="myIncompleteInterventionsList"
              matSort
              matSortDisableClear
              [matSortActive]="defaultSortActiveMyIncompleteInterventions"
              [matSortDirection]="defaultSortDirectionMyIncompleteInterventions"
              class="my-incomplete-interventions-table-header-sticky"
              (matSortChange)="announceSortChangeMyIncompleteInterventions($event)"
            >
              <ng-container matColumnDef="key">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
                <td mat-cell *matCellDef="let row">
                  {{ row?.key }}
                </td>
              </ng-container>

              <ng-container matColumnDef="driverID">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Driver Id</th>
                <td mat-cell *matCellDef="let row">
                  {{ row?.driverID }}
                </td>
              </ng-container>

              <ng-container matColumnDef="reason">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Reason</th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="reason-column"
                  matTooltip="{{ row?.reason }}"
                >
                  {{ row?.reason }}
                </td>
              </ng-container>

              <ng-container matColumnDef="dueDate">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Due Date</th>
                <td mat-cell *matCellDef="let row">
                  {{ row?.dueDate ? convertDateFormat(row?.dueDate) : "" }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumnsMyIncompleteInterventions"
              ></tr>
              <tr
                mat-row
                class="clickable"
                *matRowDef="let row; columns: displayedColumnsMyIncompleteInterventions"
                (click)="onInterventionRowClick(row)"
              ></tr>
            </table>
          </div>
          <div
            class="no-data"
            *ngIf="
              showNoDataAvailableMyIncompleteInterventions &&
              !isLoadingMyIncompleteInterventionsList
            "
          >
            No data available
          </div>
          <ng-container *ngIf="isLoadingMyIncompleteInterventionsList">
            <ng-container *ngTemplateOutlet="loadingTemplateOverlay"></ng-container>
          </ng-container>
          <mat-paginator
            *ngIf="!isLoadingMyIncompleteInterventionsList"
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons
            [pageSize]="pageEventMyIncompleteInterventions.pageSize"
            [length]="paginationParamsMyIncompleteInterventions.total"
            [pageIndex]="pageEventMyIncompleteInterventions.pageIndex"
            (page)="onPageChangeMyIncompleteInterventions($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- New section for My Interventions with Negative Score Changes -->
    <div
      *ngIf="!showWelcomeMessage && canManageInterventions()"
      class="negative-score-section"
    >
      <div class="rectangle">
        <div class="section-header">
          <div class="table-subtitle">My Interventions with Negative Score Changes</div>
          <div
            class="new-radio-slider button-toggle-right button-toggle-right-second-slider negative-slider-container"
          >
            <input
              type="radio"
              name="negativePeriod"
              id="negativeOption7"
              class="new-radio-input"
              [value]="'7'"
              [(ngModel)]="selectedNegativeScorePeriod"
            />
            <label
              (click)="onNegativeScorePeriodChange('7')"
              for="negativeOption7"
              class="new-radio-label"
              >7 Days</label
            >
            <input
              type="radio"
              name="negativePeriod"
              id="negativeOption30"
              class="new-radio-input"
              [value]="'30'"
              [(ngModel)]="selectedNegativeScorePeriod"
            />
            <label
              (click)="onNegativeScorePeriodChange('30')"
              for="negativeOption30"
              class="new-radio-label"
              >30 Days</label
            >
            <input
              type="radio"
              name="negativePeriod"
              id="negativeOption90"
              class="new-radio-input"
              [value]="'90'"
              [(ngModel)]="selectedNegativeScorePeriod"
            />
            <label
              (click)="onNegativeScorePeriodChange('90')"
              for="negativeOption90"
              class="new-radio-label"
              >90 Days</label
            >
            <div class="slider"></div>
          </div>
        </div>
        <div class="container-table">
          <div class="table-responsive">
            <div class="table-container scrollable-container">
              <table
                mat-table
                [dataSource]="negativeScoreChangesList"
                matSort
                matSortDisableClear
                [matSortActive]="defaultSortActiveNegativeScoreChanges"
                [matSortDirection]="defaultSortDirectionNegativeScoreChanges"
                class="driver-coaching-table table-header-sticky"
                (matSortChange)="announceSortChangeNegativeScoreChanges($event)"
              >
                <!-- Driver Name -->
                <ng-container matColumnDef="driverName">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Driver Name</th>
                  <td mat-cell *matCellDef="let element">
                    {{ toTitleCase(element.driverName) }}
                  </td>
                </ng-container>

                <!-- Driver ID -->
                <ng-container matColumnDef="driverId">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Driver ID</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.driverId }}
                  </td>
                </ng-container>

                <!-- ID# -->
                <ng-container matColumnDef="ufId">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>ID#</th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      style="text-decoration: underline; cursor: pointer"
                      (click)="onNegativeScoreInterventionSelected(element)"
                    >
                      {{ element?.ufId }}
                    </span>
                  </td>
                </ng-container>

                <!-- Event Types -->
                <ng-container matColumnDef="eventTypes">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Event Types</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element?.eventTypes }}
                  </td>
                </ng-container>

                <!-- Days Since Intervention -->
                <ng-container matColumnDef="daysSinceIntervention">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Days Since Intervention
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span class="column-centered">{{
                      element?.daysSinceIntervention
                    }}</span>
                  </td>
                </ng-container>

                <!-- Score Before Intervention -->
                <ng-container matColumnDef="scoreBeforeIntervention">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Score Before Intervention
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span class="column-centered">
                      <div class="block-count-change">
                        <span class="count-change">{{
                          (element?.scoreBeforeIntervention ?? 0) / 10 | number : "1.0-1"
                        }}</span>
                        <app-star-rating
                          [type]="element.scoreTierBeforeIntervention"
                        ></app-star-rating>
                      </div>
                    </span>
                  </td>
                </ng-container>

                <!-- Score Change -->
                <ng-container matColumnDef="scoreChange">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>Score Change</th>
                  <td mat-cell *matCellDef="let element">
                    <app-score-change
                      [scoreChange]="element?.scoreChange"
                    ></app-score-change>
                  </td>
                </ng-container>

                <!-- Score After Intervention -->
                <ng-container matColumnDef="scoreAfterIntervention">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Score After Intervention
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span class="column-centered">
                      <div class="block-count-change">
                        <span class="count-change">{{
                          (element?.scoreAfterIntervention ?? 0) / 10 | number : "1.0-1"
                        }}</span>
                        <app-star-rating
                          [type]="element.scoreTierAfterIntervention"
                        ></app-star-rating>
                      </div>
                    </span>
                  </td>
                </ng-container>

                <!-- Completion Date -->
                <ng-container matColumnDef="completedDate">
                  <th mat-header-cell mat-sort-header *matHeaderCellDef>
                    Completion Date
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span class="column-centered">{{
                      element.completedDate | date : "MM/dd/yyyy"
                    }}</span>
                  </td>
                </ng-container>

                <!-- Header and Row Definitions -->
                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsNegativeScoreChanges"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsNegativeScoreChanges"
                  class="clickable"
                  (click)="onNegativeScoreInterventionSelected(row)"
                ></tr>
              </table>
            </div>
            <div
              class="no-data"
              *ngIf="
                showNoDataAvailableNegativeScoreChanges && !isLoadingNegativeScoreChanges
              "
            >
              No data available
            </div>
            <ng-container *ngIf="isLoadingNegativeScoreChanges">
              <ng-container *ngTemplateOutlet="loadingTemplateOverlay"></ng-container>
            </ng-container>
            <mat-paginator
              *ngIf="!isLoadingNegativeScoreChanges"
              [pageSizeOptions]="pageSizeOptions"
              showFirstLastButtons
              [pageSize]="pageEventNegativeScoreChanges.pageSize"
              [length]="paginationParamsNegativeScoreChanges.total"
              [pageIndex]="pageEventNegativeScoreChanges.pageIndex"
              (page)="onPageChangeNegativeScoreChanges($event)"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="spinner-container">
    <mat-progress-spinner
      mode="indeterminate"
      [diameter]="30"
      class="spinner-cards"
    ></mat-progress-spinner>
  </div>
</ng-template>

<ng-template #loadingTemplateOverlay>
  <div class="spinner-overlay">
    <mat-progress-spinner
      mode="indeterminate"
      [diameter]="30"
      class="spinner"
    ></mat-progress-spinner>
  </div>
</ng-template>
